module.exports = __webpack_public_path__ + "img/mission.45c2157a.png";